import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';

import { Table, Text, Link } from './styles';

const CustomTable = (props) => {
  const { receipts } = props;

  return (
    <Table basic="very">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>
            <Text.Bold>Date</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Amount</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell />
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {!_.isEmpty(receipts) && _.orderBy(receipts, ['date'], ['desc']).map((receipt) => (
          <Table.Row key={receipt.id}>
            <Table.Cell>
              <Text>{moment(receipt.date).format('LL')}</Text>
            </Table.Cell>

            <Table.Cell>
              <Text>{receipt.amount}</Text>
            </Table.Cell>
            <Table.Cell>
              <Link href={receipt.receiptUrl} target="_blank">View Receipt</Link>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

CustomTable.propTypes = {
  receipts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      receiptUrl: PropTypes.string,
      amount: PropTypes.string,
      date: PropTypes.string,
    }),
  ).isRequired,
};

export default CustomTable;
